<template>
  <div :class="{ 'has-logo': showLogo }"
    :style="{ display: device === 'mobile' ? 'block' : 'flex', height: device === 'mobile' ? 'auto' : '52px' }"
    class="hasNanvs">
    <el-scrollbar wrap-class="scrollbar-wrapper" class="scroll">
      <el-menu :default-active="activeMenu" :collapse="isCollapse" :unique-opened="false"
        :active-text-color="variables.menuActiveText" :collapse-transition="false"
        :mode="device === 'mobile' ? 'vertical' : 'horizontal'">
        <sidebar-item v-for="route in filteredRoutes" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";

export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters(["sidebar"]),
    routes() {
      return this.$router.options.routes;
    },
    filteredRoutes() {
      return this.routes.map(route => {
        if (route.name === '兼职管理' || route.name === '商户岗位审核' || route.name === '用户列表' || route.name === '商户列表' || route.name === '商机管理') {
          return {
            ...route,
            children: route.children.filter(child => child.meta)
          };
        }
        return route;
      }).filter(route => {
        return !(route.name === '兼职管理' || route.name === '商户岗位审核'|| route.name === '用户列表' || route.name === '商户列表' || route.name === '商机管理') || route.children.length > 0;
      });
    },
    activeMenu() {
      const { meta, path } = this.$route;
      return meta.activeMenu || path;
    },
    device() {
      return this.$store.state.app.device;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 770px) and (max-width: 1980px) {
  .sidebar {
    box-shadow: none !important;
  }

  .scroll {
    width: 80vw !important;
    height: 52px !important;
    overflow-y: hidden !important;
  }
}

@media screen and (max-width: 760px) {
  .hasNanvs {
    width: 140px !important;
    background-color: #fff;
  }

  .scroll {
    width: 140px !important;
    height: 100% !important;
    overflow-y: auto !important;
  }
}

.el-menu--horizontal {
  display: flex;
}

::v-deep .el-scrollbar__wrap {
  overflow: auto !important;
}

::v-deep .el-menu-item.is-active {
  color: rgb(51, 122, 183) !important;
}
</style>